import { Box } from '@mui/material';
import { AutomationTypes } from '../../../types/enums/AutomationTypes';
import { SelectorValueTypes } from '../../../types/enums/SelectorValueTypes';
import { SweepFieldsOperatorSelector } from '../../SweepFieldsOperatorSelector/SweepFieldsOperatorSelector';
import {
  ApiSweepFieldOperator,
  operatorHasAutomaticValue,
  SweepFieldOperatorsValues,
} from '../../SweepFieldsOperatorSelector/sweepFieldsTypesAndOperators';
import { SweepFieldsValueSelector } from '../../SweepFieldsValueSelector/SweepFieldsValueSelector';
import { getNestedPath } from '../helper';
import { NestedFieldsSelector } from '../../common/fieldsSelectors/NestedFieldsSelector';
import { colors } from '@sweep-io/sweep-design';
import { SfdcDisplayType } from '../../../types/fields';
import { useSweepFieldsInfo } from '../../../sweep-fields/useSweepFieldsInfo';

interface TriggerFieldUpdateProps {
  crmOrgId: string;

  automationJson: DeepPartial<AutomationStructureNew>;
  readonly?: boolean;
  onChangeField: (params: { leadingFieldId: string; leadingFieldLabels: string[]; fieldType: SfdcDisplayType }) => any;
  onChangeOperator: (_operator: ApiSweepFieldOperator, _value: SweepFieldOperatorsValues) => any;
  onChangeValue: (value: string) => any;
  objectName: ObjectTypeValues;
}

export const TriggerFieldUpdate = ({
  crmOrgId,
  automationJson,
  readonly,
  onChangeField,
  onChangeOperator,
  onChangeValue,
  objectName,
}: TriggerFieldUpdateProps) => {
  const JsonFieldUpdate = automationJson.automationDetails?.automationParams?.fieldUpdate;
  const { getSalesforceDisplayTypeFromFieldId } = useSweepFieldsInfo();
  const { _leadingFieldId, _leadingFieldLabels, operator, operatorValue } = JsonFieldUpdate || {};
  const sfDisplayType = getSalesforceDisplayTypeFromFieldId(_leadingFieldId);

  return (
    <>
      <Box
        sx={{
          marginRight: '8px',
          borderRadius: '4px',
          border: `1px solid ${colors.grey[300]}`,
          position: 'relative',
        }}
      >
        <NestedFieldsSelector
          disableLookupItemsResolve={true}
          crmOrgId={crmOrgId}
          objectType={objectName}
          nestedPath={getNestedPath(_leadingFieldId, _leadingFieldLabels)}
          readonly={readonly}
          onChange={(_sweepField) => {
            onChangeField({
              fieldType: _sweepField.sfDisplayType,
              leadingFieldId: _sweepField.fieldIds[0],
              leadingFieldLabels: _sweepField.fieldLabels,
            });
          }}
        />
      </Box>
      {automationJson.automationDetails?.triggerType === AutomationTypes.FieldUpdate &&
        sfDisplayType && (
          <Box
            sx={{
              marginRight: '8px',
            }}
          >
            <SweepFieldsOperatorSelector
              placeholder={'Choose option'}
              removeBorders={false}
              disabled={readonly}
              showAny
              operator={operator || undefined}
              value={operatorValue || undefined}
              sfDisplayType={sfDisplayType}
              onChange={(_operator, _value) => {
                onChangeOperator(_operator, _value);
              }}
            />
          </Box>
        )}
      {automationJson.automationDetails?.triggerType === AutomationTypes.FieldUpdate &&
        operator &&
        JsonFieldUpdate &&
        !operatorHasAutomaticValue(JsonFieldUpdate.operator as ApiSweepFieldOperator) && (
          <Box
            sx={{
              marginRight: '8px',
            }}
          >
            <SweepFieldsValueSelector
              isPicklistMultiple={sfDisplayType === SfdcDisplayType.PICKLIST ? false : undefined}
              shouldBeDisabled={readonly}
              placeholder="Value"
              parentSfDisplayType={sfDisplayType}
              initialValue={JsonFieldUpdate?.operatorValue}
              onChange={(value) => {
                onChangeValue(value);
              }}
              fieldIds={[JsonFieldUpdate._leadingFieldId]}
              crmOrgId={crmOrgId}
              valueType={SelectorValueTypes.LITERAL}
              _operator={JsonFieldUpdate.operator}
            />
          </Box>
        )}
    </>
  );
};
